import { breakpoints, Flex, Image } from '@gassan-ui'
import { Heading, Text } from '@rolex-ui'
import { rgba } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Wrap = styled.a`
  display: flex;
  position: relative;
  background: white;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;
  margin-bottom: 1.25rem;

  @media screen and (min-width: ${breakpoints.small}) {
    margin-bottom: 0;
  }

  img {
    object-fit: contain !important;
  }

  &:before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    background: transparent;
    transition: background 0.2s ease-in-out;
    pointer-events: none;
    z-index: 2;
  }

  &:hover {
    &:before {
      background: ${p => rgba(p.theme.rolex.colors.shades[900], 0.03)};
    }
  }
`

type Props = {
  href: string
  sources: string[]
  title: string
  alt?: string
  subTitle?: string
}

const ProductCard: React.FC<Props> = ({ href, sources, alt, title, subTitle }) => {
  return (
    <Wrap href={href}>
      <Image
        ratio={[1.275, 1.11]}
        sources={sources}
        loading="lazy"
        alt={alt}
        style={{ mixBlendMode: 'darken' }}
      />
      <Flex alignItems="center" flexDirection="column" justifyContent="flex-end" px="5%">
        <Heading variant="subtitle" mb="0" as="h3">
          Rolex
        </Heading>
        <Heading variant="smallTitle" mb="0" as="h3">
          {title}
        </Heading>
        {subTitle && (
          <Text variant="smallDescription" mt="2px" mb="0" textAlign="center">
            {subTitle}
          </Text>
        )}
      </Flex>
    </Wrap>
  )
}

export default ProductCard
